import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';

import { environment } from './environments/environment';

import { APP_VERSION } from './services/utility.service';

import './extensions/date.extensions';

if (!environment.development) {
  enableProdMode();

  const sentryIntegrations = [Sentry.browserTracingIntegration()];

  if (environment.production) {
    sentryIntegrations.push(
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
        stickySession: false,
      })
    );
  }

  Sentry.init({
    dsn: 'https://cb35325315ba224873c32e57bf0e3ebb@o4508369368711168.ingest.de.sentry.io/4508675427467344',

    integrations: sentryIntegrations,

    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/portal(-(dev|staging))?\.lipp\.cloud/,
    ],

    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: environment.production ? 1 : 0,

    environment: environment.development
      ? 'Development'
      : environment.staging
      ? 'Staging'
      : 'Production',

    release: APP_VERSION,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((err) => console.error(err));
